import { render } from "./Grid.vue?vue&type=template&id=2f82e6e6&scoped=true"
import script from "./Grid.vue?vue&type=script&lang=js"
export * from "./Grid.vue?vue&type=script&lang=js"

import "./Grid.vue?vue&type=style&index=0&id=2f82e6e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f82e6e6"]])

export default __exports__